
import { CSSProperties, useContext } from 'react'
import { IconMail } from '../img'
import { DataContext } from '../data/DataContext';

const StepPaymentCompleted = () => {

    const { vidaCR } = useContext(DataContext)

    const style: CSSProperties = {
        display: 'flex',
        justifyContent: 'center'
    }

    const Download = (e: any) => {
        e.preventDefault();
        vidaCR.downloadReceipts(vidaCR.statusAccount);
    }

    const Siguiente = (e: any) => {
        e.preventDefault();
        vidaCR.viewFinishPage(vidaCR);
    }

    return <>
        <div>
            <label style={{ ...style, textAlign: 'center', fontSize: '20px', color: '#008866', lineHeight: '30px' }}>¡Gracias por confiar en <br></br> seguro LAFISE!</label>
            <label className='mt-30' style={{ ...style, textAlign: 'center', fontSize: '20px', color: '#4D4D4D', lineHeight: '20px', fontWeight: 600 }}>Su pago fue un éxito </label>
            <div style={style} className='mt-30 mb-20'>
                <IconMail />
            </div>
            <p className='mt-30' style={{ ...style, textAlign: 'center', fontSize: '15px', color: '#4D4D4D' }}>
                A partir de ahora las cuotas de su <br></br> seguro serán debitadas de la tarjeta <br></br> ingresada.
            </p>

            <p className='mt-30' style={{ ...style, textAlign: 'center', fontSize: '15px', color: '#4D4D4D' }}>
                Le enviaremos el comprobante de la <br></br> actualización de su medio de pago.

            </p>
        </div>

        <div style={style} className='mt-30'>
            <button className='btn-auto-cr  back-auto-cr' type="button" onClick={Download}>Descargar recibo</button>
        </div>

        <div style={style} className='mt-20 mb-30'>
            <button className='btn-auto-cr next-auto-cr' onClick={Siguiente} >Siguiente</button>
        </div>
    </>
}
export { StepPaymentCompleted }